module.exports = __webpack_public_path__ + "static/media/9DESA27.0aaf45a2.jpg";